type AdvisorFeatureFlagKey = Exclude<AppConfigFeatureFlagKey, 'advisorAccountActivation'>;

/**
 * Must list every advisor-editable AppConfig flag. Client-only flags are
 * intentionally excluded from the advisor and flag-centric views.
 */
const KNOWN_FLAG_KEY_MAP: Record<AdvisorFeatureFlagKey, true> = {
  stripe: true,
  mobileDashboardRedesign: true,
  showIntegrations: true,
  wealthbox: true,
  redtail: true,
  salesforce: true,
  ltcFinancialPlanning: true,
  hidePersonalizePlan: true,
  overviewSlide: true,
  useFormProvider: true,
  usageMetrics: true,
  nylMetrics: true,
  nylParticipationAgreement: true,
  complianceBCCEmails: true,
  newReportPdfDesign: true,
  inviteClientDialog: true,
  nycLifeDemo: true,
  customPremiumInput: true,
  shopInsurancePremiumRange: true,
  animatedSlides: true,
  stripeSubscriptionCancellation: true,
  advisorClientLogin: true,
  oneAmericaExpandedStates: true,
  hideInviteEmailAndFillIntakeForm: true,
  policiesComparisonV2: true,
  pdfRoiDisplaySettings: true,
  ltcCostRoundingOptions: true,
  coupleQuickPlan: true,
  sendPolicyViaGenworthAPI: true,
  sendPolicyViaGenworthAPIAndSftp: true,
  hideSubscriptionManagement: true,
  triggerUncancelDripCampaign: true,
  selfFundingGrowthPreview: true,
  existingLtcPolicyTypeOnCard: true,
  checkoutLeaveAndBookDemo: true,
  coverageGap: true,
  fullCare247Override: true,
  partnerFundingSplit: true,
  guidedPlanningSetPremium: true,
  guidedPlanningPremiumBudgetStep: true,
  anonymousPUI: true,
  onboardingPdfReportOptions: true,
  licensesManagement: true,
  wagClients: true,
  selfFundingAdvancedOptions: true,
  advisorIntakeGuideEmail: true,
  reactPdfReport: true,
  asyncIllustrations: true,
  structuredUnderwriting: true,
  persistentFilters: true,
  retirementIncomeExpanded: true,
  shareSpecificClients: true,
  multipleJointPolicies: true,
  rateActionLetterUpload: true,
  dynamicClientConsentCopy: true,
  claimProjectionEngineEnabled: true,
  policyModelingMaintenanceBanner: true,
  distributionPartnersEnabled: true,
  distributionPartnersForEdj: true,
  viewPolicyDocument: true,
  autoSignInConsentLink: true,
  quoteApplyCareMattersAnnuity: true,
  underwritingCareMattersAnnuity: true,
  underwritingSecureCareFour: true,
  inflationProtectionMinimum: true,
  customEmailSignature: true,
  advisorLogoBranding: true,
  perClientInviteLink: true,
  edjPerClientInviteLink: true,
  emailAISupport: true,
  magicEmailHelpArticles: true,
  magicEmailHelpArticleSharing: true,
  magicEmailAssistantPaused: true,
  magicEmailDraftReviewer: true,
  edjQuickPlan: true,
  consumerSmsMfa: true,
  crmProspecting: true,
};

export const KNOWN_FLAG_KEYS = (
  Object.keys(KNOWN_FLAG_KEY_MAP) as AdvisorFeatureFlagKey[]
).sort() as readonly AdvisorFeatureFlagKey[];

export function isKnownFlagKey(key: string): key is AdvisorFeatureFlagKey {
  return Object.prototype.hasOwnProperty.call(KNOWN_FLAG_KEY_MAP, key);
}
